(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-with-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  const root = document.querySelector('.section-{{ section.id }}');
  if(!root) return;

  const tabs = root.querySelectorAll('.collections-with-tabs__tab');
  const tabPanels = root.querySelectorAll('.collections-with-tabs__tab-panel');
  const swiperInstances = {};

  // Initialize Swiper for each tab panel
  function initializeSwipers() {
    tabPanels.forEach((panel, index) => {
      const slider = panel.querySelector('[data-product-slider]');
      if (slider && !swiperInstances[slider.dataset.productSlider]) {
        const prevBtn = panel.querySelector('.swiper-button-prev');
        const nextBtn = panel.querySelector('.swiper-button-next');
        
        swiperInstances[slider.dataset.productSlider] = new Swiper(slider, {
          slidesPerView: 6,
          spaceBetween: 10,
          freeMode: true,
          loop: true,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          breakpoints: {
            0: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 2.5
            },
            1024: {
              slidesPerView: 6
            }
          }
        });
      }
    });

    // Initialize fallback slider if no tabs
    const fallbackSlider = root.querySelector('[data-product-slider-{{ section.id }}]:not([data-product-slider-{{ section.id }}-])');
    if (fallbackSlider && !swiperInstances[fallbackSlider.dataset.productSlider]) {
      const prevBtn = root.querySelector('.swiper-{{ section.id }}-prev');
      const nextBtn = root.querySelector('.swiper-{{ section.id }}-next');
      
      if (prevBtn && nextBtn) {
        swiperInstances[fallbackSlider.dataset.productSlider] = new Swiper(fallbackSlider, {
          slidesPerView: 6,
          spaceBetween: 10,
          freeMode: true,
          loop: true,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          breakpoints: {
            0: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 2.5
            },
            1024: {
              slidesPerView: 6
            }
          }
        });
      }
    }
  }

  // Tab switching functionality
  if (tabs.length > 0) {
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function() {
        // Update tab states
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        // Update panel states
        tabPanels.forEach((panel, panelIndex) => {
          if (panelIndex === index) {
            panel.classList.add('is-active');
            panel.removeAttribute('hidden');
            
            // Initialize swiper for newly active panel if not already initialized
            const slider = panel.querySelector('[data-product-slider]');
            if (slider && !swiperInstances[slider.dataset.productSlider]) {
              const prevBtn = panel.querySelector('.swiper-button-prev');
              const nextBtn = panel.querySelector('.swiper-button-next');
              
              if (prevBtn && nextBtn) {
                swiperInstances[slider.dataset.productSlider] = new Swiper(slider, {
                  slidesPerView: 6,
                  spaceBetween: 10,
                  freeMode: true,
                  loop: true,
                  navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn
                  },
                  breakpoints: {
                    0: {
                      slidesPerView: 1.5
                    },
                    768: {
                      slidesPerView: 2.5
                    },
                    1024: {
                      slidesPerView: 6
                    }
                  }
                });
              }
            }
          } else {
            panel.classList.remove('is-active');
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  // Initialize on load - wait for Swiper to be available
  function waitForSwiper() {
    if (typeof Swiper !== 'undefined') {
      initializeSwipers();
    } else {
      setTimeout(waitForSwiper, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiper);
  } else {
    waitForSwiper();
  }

  // Keyboard navigation for tabs
  tabs.forEach((tab, index) => {
    tab.addEventListener('keydown', function(e) {
      let targetIndex = index;
      
      if (e.key === 'ArrowRight') {
        targetIndex = (index + 1) % tabs.length;
        e.preventDefault();
      } else if (e.key === 'ArrowLeft') {
        targetIndex = (index - 1 + tabs.length) % tabs.length;
        e.preventDefault();
      } else if (e.key === 'Home') {
        targetIndex = 0;
        e.preventDefault();
      } else if (e.key === 'End') {
        targetIndex = tabs.length - 1;
        e.preventDefault();
      }
      
      if (targetIndex !== index) {
        tabs[targetIndex].click();
        tabs[targetIndex].focus();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
